module.exports = __webpack_public_path__ + "img/lavorazione.edabe458.svg";